export default {"src":"/_next/static/image/src/images/Footer/footer-app-store-button.3d8aa1516b5dcf6039263e24e6c70674.svg","height":56,"width":189};